export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Маркетинг',
        path: '/cases/marketing',
    },
];

export const listTitle = [
    {
        title: 'SEO для интернет-магазина спорттоваров',
        subtitle:
            'В&nbsp;этом кейсе расскажем, какие тексты нужны интернет-магазину для роста продаж без привлечения платных рекламных инструментов, и&nbsp;покажем результаты синергии SEO и&nbsp;контента.',
        description: [
            {
                name: 'Отрасль',
                details: 'E-commerce',
            },
            {
                name: 'Услуги',
                details: 'SEO-продвижение сайта',
            },
        ],
        company: 'Интернет-магазин спортивных товаров &laquo;Медведь&raquo;',
        companyLink: 'https://www.medved-sport.ru/',
        companyLinkName: 'medved-sport.ru',
        text: 'Интернет-магазин спортивных товаров &laquo;Медведь&raquo; с&nbsp;широким ассортиментом спортивного питания, профессиональной экипировки, тренажеров и&nbsp;уличного спортивного оборудования.',
    },
];

export const listTarget = [
    {
        name: 'Цель',
        description:
            'Обеспечить поток целевого трафика на&nbsp;сайт и&nbsp;увеличить количество заявок',
    },
];

export const listTeam = [
    {
        title: 'Команда',
        members: [
            {
                name: 'Никита Булахтин',
                position: 'Менеджер проекта',
            },
            {
                name: '2 SEO-специалиста',
            },
            {
                name: 'Копирайтер',
            },
        ],
    },
];

export const listDescription = [
    {
        title: 'Описание проекта',
        text: [
            {
                paragraph:
                    'Интернет-магазин &laquo;Медведь&raquo; специализируется на&nbsp;продаже спортивных товаров и&nbsp;спортпитания. Также есть несколько офлайн-магазинов в&nbsp;Ростовской области.',
            },
            {
                paragraph:
                    'В&nbsp;условиях пандемии произошел бурный рост маркетплейсов, которые активно заняли поисковую выдачу. Из-за этого прежние подходы к&nbsp;SEO-продвижению товаров и&nbsp;услуг перестали приносить желаемые результаты.',
            },
            {
                paragraph:
                    'Для привлечения целевого трафика на&nbsp;сайт в&nbsp;качестве гипотезы мы&nbsp;предложили попробовать контент-инструменты, чтобы охватить информационные запросы. Статьи&nbsp;&mdash; это не&nbsp;уникальное решение, но&nbsp;важен формат и&nbsp;стиль текстов. Для интернет-магазина с&nbsp;большим ассортиментом разных групп товаров остановились на&nbsp;формате рейтингов/топов.',
            },
        ],
        description:
            'Интернет-магазинам пришлось конкурировать с&nbsp;маркетплейсами по&nbsp;прямым коммерческим запросам, что значительно усложнило продвижение.',
        subtitle: 'Пример заголовка статьи',
        img: '/images/pic/medved/descriptionImg.jpg',
    },
];

export const listProcess = [
    {
        title: 'Процесс',
        description:
            'Тексты должны быть релевантными под запрос пользователей, содержать точную и&nbsp;полезную информацию, иметь максимальный процент дочитывания.',
        subtitle: 'Команда копирайтеров и&nbsp;SEO-специалистов работала по&nbsp;следующему плану:',
        list: [
            {
                number: '1.',
                text: 'Собираем семантическое ядро по&nbsp;подходящим информационным запросам.',
            },
            {
                number: '2.',
                text: 'Группируем запросы и&nbsp;выделяем приоритетные темы для статей на&nbsp;основании частотности запросов.',
            },
            {
                number: '3.',
                text: 'Составляем план статьи и&nbsp;передаем техзадание копирайтерам.',
            },
            {
                number: '4.',
                text: 'Согласовываем текст с&nbsp;заказчиком.',
            },
            {
                number: '5.',
                text: 'Размещаем статью на&nbsp;сайте интернет-магазина.',
            },
            {
                number: '6.',
                text: 'Мониторим позиции и&nbsp;результаты, если необходимо, вносим правки.',
            },
        ],
        secondText:
            'Важно найти узкоспециализированные темы, но&nbsp;в&nbsp;то&nbsp;же время пользующиеся спросом у&nbsp;аудитории.',
    },
];

export const listText = {
    main: [
        {
            id: '1',
            text: 'Оптимальный объем текста для SEO-статьи 5 000&ndash;6&nbsp;000&nbsp;знаков. Но&nbsp;все-таки главным приоритетом для нас была топовая конкурентная тема, а&nbsp;не&nbsp;объем.',
        },
        {
            id: '2',
            text: 'В&nbsp;работе с&nbsp;текстами также важна скорость согласования темы и&nbsp;готовой статьи. От&nbsp;этого напрямую зависит трафик. У&nbsp;нас с&nbsp;клиентом в&nbsp;этом плане отличная коммуникация, и&nbsp;процесс согласования текста занимает не&nbsp;более одного рабочего дня.',
        },
    ],
    minor: [
        {
            id: '1',
            description:
                'Чтобы получить нативный трафик, тема статьи должна быть конкурентная по&nbsp;запросам.',
        },
    ],
};
export const listTextMetrics = {
    main: [
        {
            id: '1',
            text: 'После публикации отправляем ссылки на&nbsp;индексацию через &laquo;Яндекс.Вебмастер&raquo; и&nbsp;в&nbsp;Google Search Console, чтобы поисковики быстрее обратили внимание.',
        },
        {
            id: '2',
            text: 'Далее обязательно мониторим результаты и&nbsp;оптимизируем текст исходя из&nbsp;списка дополнительных запросов, которые, возможно, не&nbsp;были учтены в&nbsp;семантическом ядре изначально.',
        },
        {
            id: '3',
            text: 'Наша команда регулярно коммуницирует с&nbsp;заказчиком и&nbsp;планирует работы на&nbsp;3&nbsp;месяца вперед. На&nbsp;этот срок определяются и&nbsp;темы для статей на&nbsp;основе семантики.',
        },
        {
            id: '4',
            text: 'Первые результаты от&nbsp;реализации нашей гипотезы увидели сразу и&nbsp;продолжаем использовать этот инструмент до&nbsp;сих пор, как приоритетный для продвижения товаров интернет-магазина.',
        },
    ],
    minor: [
        {
            id: '1',
            description: 'Индексируем публикации',
            image1: '/images/svg/new-medved/yandex.svg',
            image2: '/images/svg/new-medved/google.svg',
        },
    ],
};

export const listRules = [
    {
        id: '1',
        icon: '/images/svg/new-medved/rule1.svg',
        number: '01',
        text: 'Пишем заголовки, которые отвечают основным запросам целевой аудитории',
    },
    {
        id: '2',
        icon: '/images/svg/new-medved/rule2.svg',
        number: '02',
        text: 'Формируем содержание для удобной навигации по&nbsp;смысловым частям статьи',
    },
    {
        id: '3',
        icon: '/images/svg/new-medved/rule3.svg',
        number: '03',
        text: 'Пишем тексты с&nbsp;уникальностью&nbsp;90% и&nbsp;выше',
    },
    {
        id: '4',
        icon: '/images/svg/new-medved/rule4.svg',
        number: '04',
        text: 'Добавляем товары из&nbsp;каталога и&nbsp;перелинковку, чтобы можно было перейти в&nbsp;карточку',
    },
    {
        id: '5',
        icon: '/images/svg/new-medved/rule5.svg',
        number: '05',
        text: 'Ставим метрики и&nbsp;настраиваем цели, чтобы отслеживать переходы с&nbsp;каждого текста',
    },
];

export const listStatistic = [
    {
        subtitle:
            'Статья &laquo;Какой коллаген лучше выбрать: топ-10 эффективных комплексов&raquo;',
        link: 'https://www.medved-sport.ru/services/biblioteka-sporta/sportivnoe-pitanie/kakoy-kollagen-luchshe-vybrat-top-10-effektivnykh-kompleksov/',
        info: [
            {
                text: 'Посетители',
                icon: '/images/svg/new-medved/people-icon.svg',
                number: '147 199',
            },
            {
                text: 'Переход к товарам',
                icon: '/images/svg/new-medved/cube-icon.svg',
                number: '26 528',
            },
            {
                text: 'Заказы',
                icon: '/images/svg/new-medved/like-icon.svg',
                number: '50',
            },
        ],
    },
    {
        subtitle: 'Статья &laquo;Препараты для повышения тестостерона: топ-10&nbsp;лучших&raquo;',
        link: 'https://www.medved-sport.ru/services/biblioteka-sporta/sportivnoe-pitanie/preparaty-dlya-povysheniya-testosterona-top-10-luchshikh/',
        info: [
            {
                text: 'Посетители',
                icon: '/images/svg/new-medved/people-icon.svg',
                number: '105 261',
            },
            {
                text: 'Переход к товарам',
                icon: '/images/svg/new-medved/cube-icon.svg',
                number: '8 779',
            },
            {
                text: 'Заказы',
                icon: '/images/svg/new-medved/like-icon.svg',
                number: '94',
            },
        ],
    },
    {
        subtitle:
            'Статья &laquo;Топ-10 лучших препаратов для лечения суставов и&nbsp;связок после спортивных травм&raquo;',
        link: 'https://www.medved-sport.ru/services/biblioteka-sporta/sportivnoe-pitanie/top-10-luchshikh-lekarstv-dlya-lecheniya-sustavov-i-svyazok-posle-sportivnykh-travm/',
        info: [
            {
                text: 'Посетители',
                icon: '/images/svg/new-medved/people-icon.svg',
                number: '43 187',
            },
            {
                text: 'Переход к товарам',
                icon: '/images/svg/new-medved/cube-icon.svg',
                number: '5 142',
            },
            {
                text: 'Заказы',
                icon: '/images/svg/new-medved/like-icon.svg',
                number: '12',
            },
        ],
    },
];

export const listTextStatic = {
    main: [
        {
            id: '1',
            text: 'Рекордное количество трафика удалось привести в&nbsp;ноябре 2022&nbsp;&mdash; январе 2023. Только за&nbsp;эти три месяца суммарно на&nbsp;сайт зашли 242&nbsp;300 уникальных посетителей. При этом среднее время на&nbsp;сайте составило 2,00, средние отказы 10,3%.',
        },
    ],
};

export const listResults = [
    {
        text: 'Статьи',
        icon: '/images/svg/new-medved/lines.svg',
        number: '12',
    },
    {
        text: 'Визиты',
        icon: '/images/svg/new-medved/visits.svg',
        number: '632 604',
        percent: '+394%',
    },
    {
        text: 'Посетители',
        icon: '/images/svg/new-medved/people-icon.svg',
        number: '513 503',
        percent: '+403%',
    },
];
